<template>
  <div class="videoBlock web_pic_item">
    <div class="video">
      <div class="iframe">
        <div
          :title="video.nodeName"
          v-if="video.originalFilePath"
          v-html="video.originalFilePath"
        ></div>
        <div v-else>
          <img :src="fakeVideo" alt="" />
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 影音平台 -->
      <div class="tag" :class="{ article_2: video.nodeName === '影音專區' }">
        <p :style="{ fontSize: fontSize.p + 'em' }">{{ video.nodeName }}</p>
      </div>
      <router-link
        :to="{ name: justify, params: { id: video.vid } }"
        class="text_title"
      >
        <div class="title text_content">
          <h3 :style="{ fontSize: fontSize.h5 + 'em' }">{{ video.title }}</h3>
        </div>
      </router-link>
      <div class="date">
        <p :style="{ fontSize: fontSize.p + 'em' }">{{ video.uploadDate }}</p>
      </div>
      <div class="words ellipsis">
        <p :style="{ fontSize: fontSize.p + 'em' }" v-html="video.abstract"></p>
      </div>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
import { fakeVideo } from "@/fake_data.js";

export default {
  name: "VideoBlock",
  props: {
    video: {
      type: Object,
      required: true,
    },
    justify: {
      type: String,
      required: true,
    },
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
      fakeVideo,
    };
  },
};
</script>

<style lang="scss" scoped>
.videoBlock {
  background-color: $bgc_gray;
  display: flex;
  justify-content: flex-start;
  padding: 25px;
  margin-bottom: 25px;
  .video {
    width: 470px;
    height: 100%;
    overflow: hidden;
    .iframe {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      :deep iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
  @include sm {
    // margin: 0 50px;
    flex-direction: column;
    .content {
      padding-top: 10px;
      div {
        padding: 5px 0;
      }
    }
    .video {
      width: 100%;
      align-self: center;
    }
    .tag {
      margin-top: 10px;
    }
  }

  .content {
    padding: 0 20px;
    width: -webkit-fill-available;
    div {
      padding-bottom: 5px;
    }
    .text_title {
      display: flex;
    }
    .tag {
      background-color: $black_color;
      color: #fff;
      padding: 3px 10px;
      width: 90px;
      &.article_2 {
        background-color: #026764;
      }
    }
    .date {
      color: #9e9e9e;
      text-align: initial;
    }
    .words,
    .title {
      text-align: initial;
    }
    .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      white-space: normal;
    }
  }
}
</style>
